import { useCallback, useId } from "react";

const ToggleSwitch = ({
  checked = false,
  onChange,
  disabled = false,
}: {
  checked?: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) => {
  const id = useId();
  const handleChange = useCallback(() => {
    onChange(!checked);
  }, [checked, onChange]);
  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        // checked={checked}
        onChange={() => handleChange()}
        className="hidden"
        disabled={disabled}
      />
      <label
        htmlFor={id}
        className={`
          cursor-pointer relative flex items-center
          min-w-[60px] h-7 px-4 rounded-full transition-colors
          ${checked ? "bg-orange-400" : "bg-gray-300"}
          border border-gray-300 text-center
        `}
        style={{ minWidth: 80, height: 32 }}
      >
        <span
          className={`
            text-[12px] font-semibold transition-colors
            ${checked ? "pr-5 text-white" : "pl-5 text-gray"}
          `}
        >
          매주등원
        </span>
        {/* 토글 핸들 */}
        <span
          className={`
            absolute top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-white shadow transition-all duration-200
            ${checked ? "right-2" : "left-2"}
          `}
          style={{
            left: checked ? "auto" : 8,
            right: checked ? 8 : "auto",
          }}
        />
      </label>
    </div>
  );
};
export default ToggleSwitch;
